// frontend/admin-portal/src/components/suppliers/SupplierProductsPanel.jsx
import React, { useState } from "react";
import { Button, Table, Badge, Card } from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";
import { supplierService } from "../../services/supplierService";
import SupplierLinkProductModal from "./SupplierLinkProductModal";

export default function SupplierProductsPanel({ supplier, onChanged }) {
  const navigate = useNavigate();
  const [linkOpen, setLinkOpen] = useState(false);

  const links = supplier?.supplierProducts || [];
  const alreadyLinkedIds = links.map((l) => l.productId);

  const unlink = async (link) => {
    if (!window.confirm(`Unlink "${link.product?.name}"?`)) return;
    try {
      await supplierService.unlinkProduct(supplier.id, link.productId);
      onChanged?.();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  const togglePreferred = async (link) => {
    try {
      await supplierService.updateLink(supplier.id, link.productId, {
        isPreferred: !link.isPreferred,
      });
      onChanged?.();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  const columns = [
    {
      key: "product",
      label: "Product",
      render: (r) => (
        <div
          onClick={() => r.product?.id && navigate(`/products/${r.product.id}`)}
          style={{ cursor: "pointer" }}
        >
          <div style={{ fontWeight: 600 }}>{r.product?.name || "—"}</div>
          <div className="text-muted" style={{ fontSize: 12 }}>
            {r.product?.sku}{" "}
            {r.product?.category ? `· ${r.product.category.name}` : ""}
          </div>
        </div>
      ),
    },
    {
      key: "supplierSku",
      label: "Supplier SKU",
      render: (r) => r.supplierSku || <span className="text-muted">—</span>,
    },
    {
      key: "supplierCost",
      label: "Supplier Cost",
      render: (r) =>
        r.supplierCost ? (
          <strong>{Number(r.supplierCost).toLocaleString()}</strong>
        ) : (
          <span className="text-muted">—</span>
        ),
    },
    {
      key: "leadTimeDays",
      label: "Lead Time",
      render: (r) =>
        r.leadTimeDays ? (
          `${r.leadTimeDays} days`
        ) : (
          <span className="text-muted">—</span>
        ),
    },
    { key: "minOrderQty", label: "Min Qty", render: (r) => r.minOrderQty || 1 },
    {
      key: "isPreferred",
      label: "Preferred",
      render: (r) => (
        <button
          type="button"
          className={`fh-pref-star ${r.isPreferred ? "is-on" : ""}`}
          onClick={() => togglePreferred(r)}
          title={r.isPreferred ? "Preferred" : "Not preferred"}
        >
          ★
        </button>
      ),
    },
    {
      key: "actions",
      label: "",
      width: 100,
      render: (r) => (
        <Button size="sm" variant="ghost" onClick={() => unlink(r)}>
          Unlink
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card
        title={`Linked Products (${links.length})`}
        actions={
          <Button variant="primary" size="sm" onClick={() => setLinkOpen(true)}>
            + Link Product
          </Button>
        }
      >
        <Table
          columns={columns}
          data={links}
          loading={false}
          emptyMessage="No products linked to this supplier yet"
        />
      </Card>

      <SupplierLinkProductModal
        open={linkOpen}
        supplier={supplier}
        alreadyLinkedIds={alreadyLinkedIds}
        onClose={() => setLinkOpen(false)}
        onLinked={onChanged}
      />
    </>
  );
}
